/*@ngInject*/
const ReactivateSubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.reactivate = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/reactivate',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('reactivateSubmissionRepository', ReactivateSubmissionRepository);
